// 海角网首页静态内容数据（仅展示用，不接接口）

export const TICKER_ITEMS = [
  "今日新增论坛爆料 3 条，神贴更新 2 篇，速览讨论现场。",
  "某职场爆料楼一夜盖过 4000 层，海角网已同步精选搬运。",
  "天涯热帖「小城返乡记」连载破万楼，编辑部本周深度追踪。",
  "论坛八卦栏目改组，新增话题标签方便按瓜索帖。",
  "神贴仓库本周补档：十年前那篇爆款长文重见天日。",
];

export interface HotPost {
  id: number;
  title: string;
  excerpt: string;
  tag: string;
  heat: number;
  meta: string;
}

export const HOT_POSTS: HotPost[] = [
  {
    id: 1,
    title: "我在三线城市开自习室，被整个论坛笑了一个月",
    excerpt: "从选址踩雷到会员跑路，楼主把踩过的每一个坑都写成了连续剧，评论区硬是给盖到四千多层，句句是过来人的血泪。",
    tag: "职场",
    heat: 462,
    meta: "热帖 · 4126 楼",
  },
  {
    id: 2,
    title: "深夜爆料：某网红探店视频背后，其实是另一套剧本",
    excerpt: "有图有内情，楼主放出一段花絮对比，声称现场「干净得不像样」，楼下吵到凌晨三点仍未散场。",
    tag: "爆料",
    heat: 391,
    meta: "瓜 · 2.1k 点赞",
  },
  {
    id: 3,
    title: "租房十年，我终于把房东告赢了：全程复盘帖",
    excerpt: "从押金纠纷到取证技巧，作者按时间线把自己维权全程掰开揉碎讲清楚，被称「保姆级法律科普」。",
    tag: "社会",
    heat: 355,
    meta: "干货 · 89 转",
  },
  {
    id: 4,
    title: "独立开发三个月，我把副业做成主业的这一年",
    excerpt: "不贩卖焦虑也不灌鸡汤，只写真实数据：上线、停更、复活，再到被收购未遂，一路看得很上头。",
    tag: "数码",
    heat: 318,
    meta: "热帖 · 2033 楼",
  },
  {
    id: 5,
    title: "相亲市场的隐形门槛，远比我以为的扎心",
    excerpt: "一篇观察帖意外走红，作者说自己也分不清是在劝退还是在劝进，评论区直接分成两派论战。",
    tag: "情感",
    heat: 287,
    meta: "热帖 · 1588 楼",
  },
  {
    id: 6,
    title: "老小区加装电梯，三楼和六楼在楼栋群里撕了半个月",
    excerpt: "从分摊比例吵到采光补偿，文字直播式更新，被网友评为「年度最真实社区连续剧」。",
    tag: "社会",
    heat: 244,
    meta: "楼 · 1210 层",
  },
];

export interface FeaturedPick {
  id: number;
  kicker: string;
  title: string;
  excerpt: string;
  image: string;
}

export const FEATURED_PICKS: FeaturedPick[] = [
  {
    id: 1,
    kicker: "编辑部精选 · 职场",
    title: "毕业五年，混得最好的同学，并没有在写字楼里",
    excerpt: "一篇把「体面」二字重新定义的帖子，看哭了不少深夜通勤的人。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20cover%20illustration%2C%20warm%20crimson%20cream%20and%20ink%20palette%2C%20a%20single%20window%20at%20night%20showing%20a%20lone%20desk%20worker%20silhouette%20inside%20an%20office%20building%2C%20collaged%20torn-paper%20newsprint%20texture%20edges%2C%20cinematic%20moody%20lighting%2C%20hand-drawn%20magazine%20art%20style%20with%20subtle%20grain%2C%20clean%20balanced%20composition%2C%20150dpi%20print%20editorial%20aesthetic&width=1200&height=800&seq=featured-workplace-01&orientation=landscape",
  },
  {
    id: 2,
    kicker: "编辑部精选 · 城市",
    title: "小城返乡记：我终于在菜市场找回了生活感",
    excerpt: "慢下来的日子，被作者写成一部有声音的纪录片，评论区全是会心一笑。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20illustration%20in%20warm%20paper%20cream%20and%20terracotta%20palette%2C%20an%20evening%20market%20street%20in%20a%20small%20town%20with%20glowing%20lanterns%20and%20bicycles%2C%20soft%20golden%20hour%20light%2C%20painted%20gouache%20magazine%20art%20with%20collaged%20newspaper%20texture%2C%20cozy%20nostalgic%20mood%2C%20high%20detail%2C%20elegant%20print%20layout%20composition&width=1200&height=800&seq=featured-city-02&orientation=landscape",
  },
  {
    id: 3,
    kicker: "编辑部精选 · 数码",
    title: "一个老码农的自白：我用三年戒掉了「技术焦虑」",
    excerpt: "不追逐每一条新框架的浪潮，作者终于学会和手里的代码好好相处。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20cover%20art%2C%20warm%20off-white%20background%20with%20crimson%20accent%20shapes%2C%20a%20calm%20desk%20with%20a%20single%20open%20laptop%20glowing%20softly%2C%20coffee%20cup%20and%20scattered%20code%20pages%20forming%20an%20abstract%20collage%2C%20painterly%20gouache%20texture%20with%20fine%20grain%2C%20restrained%20palette%2C%20thoughtful%20modern%20print%20magazine%20aesthetic&width=1200&height=800&seq=featured-tech-03&orientation=landscape",
  },
  {
    id: 4,
    kicker: "编辑部精选 · 情感",
    title: "那些没说出口的话，才是成年人真正的告别",
    excerpt: "作者没有讲道理，只是讲了几件小事，却让楼下一整排网友破防。",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20illustration%2C%20soft%20cream%20and%20muted%20rose%20palette%2C%20two%20empty%20chairs%20facing%20a%20large%20window%20with%20sheer%20curtains%20and%20drifting%20light%20dust%2C%20quiet%20melancholic%20mood%2C%20collaged%20painterly%20gouache%20and%20newsprint%20texture%2C%20minimalist%20elegant%20magazine%20composition%2C%20high%20emotional%20restraint%20and%20detail&width=1200&height=800&seq=featured-feeling-04&orientation=landscape",
  },
];

export interface GodPost {
  id: number;
  title: string;
  excerpt: string;
  stats: string;
  image: string;
}

export const GOD_POSTS: GodPost[] = [
  {
    id: 1,
    title: "十年前的天涯神贴：一个北漂青年的「房事」自传",
    excerpt: "曾被顶上首页的长帖，如今完整搬运回海角网，依旧是那批「房事不看后悔」的镇站之选。",
    stats: "完整搬运 · 9800 楼",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20retro%20cover%20illustration%2C%20warm%20sepia%20cream%20and%20brick%20red%20palette%2C%20a%201990s%20style%20apartment%20block%20against%20a%20big%20sun%2C%20a%20lone%20young%20man%20with%20a%20suitcase%20walking%20toward%20it%2C%20vintage%20collaged%20newspaper%20texture%20and%20halftone%20grain%2C%20nostalgic%20storytelling%20mood%2C%20elegant%20print%20editorial%20style&width=1200&height=800&seq=god-city-01&orientation=landscape",
  },
  {
    id: 2,
    title: "饭局经济学：我从酒桌上读懂了中国式人情",
    excerpt: "作者说这不是攻略，只是一张被无数局养出来的「观察清单」，读起来却句句点到穴位。",
    stats: "热帖精选 · 1.2w 字",
    image: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20in%20warm%20cream%20amber%20and%20deep%20red%20palette%2C%20an%20overhead%20view%20of%20a%20round%20banquet%20table%20with%20teacups%20and%20dishes%20partly%20cleared%2C%20cigarette%20smoke%20curling%20softly%2C%20painterly%20gouache%20with%20fine%20grain%20and%20newspaper%20collage%20edges%2C%20contemplative%20storytelling%20mood%2C%20magazine%20print%20composition&width=1200&height=800&seq=god-table-02&orientation=landscape",
  },
  {
    id: 3,
    title: "别急着逃离北上广：一线生存手册之十年版",
    excerpt: "十年后回看，作者补了当年没写下去的续篇，新的注解比正文还耐读。",
    stats: "续更 · 4200 楼",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20in%20warm%20ink%20and%20amber%20palette%2C%20an%20aerial%20city%20metro%20interchange%20at%20dusk%20with%20moving%20light%20trails%2C%20a%20lone%20commuter%20walking%20across%20an%20overpass%2C%20collaged%20halftone%20and%20paper%20texture%2C%20cinematic%20storytelling%20mood%2C%20refined%20print%20editorial%20composition&width=1200&height=800&seq=god-metro-03&orientation=landscape",
  },
];

export interface LeakItem {
  id: number;
  time: string;
  source: string;
  title: string;
}

export const LEAK_FEED: LeakItem[] = [
  {
    id: 1,
    time: "14:28",
    source: "爆料速递",
    title: "有楼主放出活动后台截图，称某线下展「货不对板」，现场图与宣传海报反差被逐张对比。",
  },
  {
    id: 2,
    time: "13:41",
    source: "瓜田前线",
    title: "知名直播间的「翻车瞬间」被剪成合集，楼主张贴多角度录屏求网友评理。",
  },
  {
    id: 3,
    time: "12:05",
    source: "天涯热帖",
    title: "离职当天删光工作群聊？资深 HR 开帖分析职场上「体面退场」的边界。",
  },
  {
    id: 4,
    time: "10:52",
    source: "爆料速递",
    title: "有人晒出小区业主群聊天，物业收费项目引起整栋楼集体「吃瓜围观」。",
  },
  {
    id: 5,
    time: "09:18",
    source: "瓜田前线",
    title: "某创业公司内幕爆料楼出现反转，当事人下场回应，瓜越滚越大。",
  },
];

export interface Topic {
  name: string;
  count: number;
  note: string;
}

export const TOPICS: Topic[] = [
  { name: "职场浮沉", count: 2134, note: "离职、求职与办公室风云" },
  { name: "瓜田吃瓜", count: 1821, note: "爆料与反转的讨论现场" },
  { name: "社会观察", count: 1577, note: "楼市、教育与人情冷暖" },
  { name: "数码手记", count: 1243, note: "独立开发与工具分享" },
  { name: "情感树洞", count: 990, note: "相亲、婚恋与人间关系" },
  { name: "城市漫游", count: 861, note: "返乡、租房与小城生活" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const FAQS: FaqItem[] = [
  {
    q: "海角网的内容从哪里来？",
    a: "海角网专注整理与精选论坛热帖、天涯热帖与网络爆料，按「编辑精选 + 读者推荐」两条线收录，并尽量注明原始来源与搬运时间，方便你回到讨论现场追帖。",
  },
  {
    q: "内容多久更新一次？",
    a: "编辑部实时盯板，热帖与爆料做到当日同步；每周固定补档一批此前未收录的神贴与长文，保证你不错过任何论坛风云。",
  },
  {
    q: "为什么神贴会显示「完整搬运」？",
    a: "部分经典长帖在搬运过程中已消失或被改写，海角网会保留可考版本并标注整理说明；标注楼层的帖子则提供原讨论串的阅读路径。",
  },
  {
    q: "使用海角网需要付费吗？",
    a: "不需要。海角网目前对读者免费开放，点开即可浏览精选热帖与论坛爆料，不设会员墙、不强制登录，也不对任何内容做付费下载。",
  },
  {
    q: "如何向我投稿或推荐一个好帖？",
    a: "你可以在站内找到「读者推荐」入口提交帖子链接，编辑部每周会集中筛选；被采纳的内容会进入编辑精选或神贴仓库，并保留原作者署名。",
  },
];

export const HERO_FEATURE = {
  kicker: "今日封面 · 天涯热帖",
  title: "那位劝退全村的楼主，其实藏了一整个反转",
  excerpt:
    "开楼时人人看热闹，看到后面才发现热闹底下是另一层。从「吐槽帖」变成「纪实连载」，这篇天涯热帖只用了三晚上——点进来，你会明白为什么评论区停不下来。",
  meta: "神贴 · 热度 826 · 8400 楼",
};

export const HERO_COVER =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20cover%20portrait%2C%20warm%20cream%20paper%20base%20with%20bold%20crimson%20masthead%20frame%20and%20ink%20typographic%20rules%2C%20abstract%20collaged%20news-thread%20composition%20of%20torn%20paper%20slips%20glowing%20discussion%20bubbles%20and%20a%20dramatic%20red%20wave%20swoosh%2C%20painterly%20gouache%20texture%20with%20fine%20grain%20and%20halftone%20dots%2C%20strong%20graphic%20contrast%2C%20premium%20print%20editorial%20aesthetic%2C%20balanced%20vertical%20composition&width=1000&height=1300&seq=hero-cover-2026&orientation=portrait";